// @flow
import BaseCollection from "../base/BaseCollection";
import SourceReferenceModel from "./SourceReferenceModel";
import type { ModelOptions } from "../types";

/**
 * Source reference collection
 */
export default class SourceReferenceCollection extends BaseCollection<SourceReferenceModel> {
  /**
   */
  constructor(
    sourceReferences: Array<Object> = [],
    sectionReferenceTypes: Array<Object> = [],
    entryDate: ?ISO_DATE = null,
    modelOptions?: ModelOptions,
  ) {
    super();

    this.collection = sourceReferences
      ? sourceReferences.map((sourceReference) => {
          const sectionReferenceType = sectionReferenceTypes.find(
            (type) => type._id === sourceReference.type,
          );
          return new SourceReferenceModel(
            { typeLabel: sectionReferenceType?.label, ...sourceReference },
            entryDate,
            modelOptions,
          );
        })
      : [];
  }

  /**
   */
  byTypes(types: string): Array<SourceReferenceModel> {
    return this.filter((sourceRef) => types.includes(sourceRef.type));
  }
}
